var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0938 7.75C28.0938 7.3875 27.9125 7.11562 27.6406 6.93437L21.2969 3.30937C21.1156 3.21875 21.025 3.21875 20.8438 3.21875C20.6625 3.21875 20.5719 3.21875 20.3906 3.30937L14.5 6.6625L8.60938 3.30937C8.42812 3.21875 8.3375 3.21875 8.15625 3.21875C7.975 3.21875 7.88438 3.21875 7.70312 3.30937L1.35938 6.93437C1.0875 7.11562 0.90625 7.3875 0.90625 7.75V25.875C0.90625 26.4188 1.26875 26.7812 1.8125 26.7812C1.99375 26.7812 2.08437 26.6906 2.26562 26.6906L8.15625 23.3375L14.0469 26.6906C14.2281 26.7812 14.3187 26.7812 14.5 26.7812C14.6813 26.7812 14.7719 26.7812 14.9531 26.6906L20.8438 23.3375L26.7344 26.6906C26.825 26.7812 27.0062 26.7812 27.1875 26.7812C27.7313 26.7812 28.0938 26.4188 28.0938 25.875V7.75ZM2.71875 8.29375L7.25 5.66562V21.7062L2.71875 24.3344V8.29375ZM13.5938 24.3344L9.0625 21.7062V5.66562L13.5938 8.29375V24.3344ZM19.9375 21.7062L15.4062 24.3344V8.29375L19.9375 5.66562V21.7062ZM21.75 21.7062V5.66562L26.2812 8.29375V24.3344L21.75 21.7062Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonplan);
export default __webpack_public_path__ + "static/media/carbonplan.0d114407026ff8433219883133e4c48a.svg";
export { ForwardRef as ReactComponent };